import { render, staticRenderFns } from "./OrderHyzk.vue?vue&type=template&id=04d9a0be&scoped=true&"
import script from "./OrderHyzk.vue?vue&type=script&lang=js&"
export * from "./OrderHyzk.vue?vue&type=script&lang=js&"
import style0 from "./OrderHyzk.vue?vue&type=style&index=0&id=04d9a0be&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04d9a0be",
  null
  
)

export default component.exports